export default __webpack_public_path__ + "static/media/airstrapz-bpk-1.4a51ed32.png";